import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ObterCalendariosPublicacoesState } from "../reducers/obter-calendarios-publicacoes.reducer";

export const selectObterCalendariosPublicacoesState = createFeatureSelector<ObterCalendariosPublicacoesState>('obterCalendariosPublicacoes');

export const selectDadosObterCalendariosPublicacoes = createSelector(
  selectObterCalendariosPublicacoesState,
  (state: ObterCalendariosPublicacoesState) => state.response
);

export const selectObterCalendariosPublicacoes = createSelector(
  selectObterCalendariosPublicacoesState,
  (state: ObterCalendariosPublicacoesState) => state
);

export const selectErrosObterCalendariosPublicacoes = createSelector(
  selectObterCalendariosPublicacoesState,
  (state: ObterCalendariosPublicacoesState) => state.error
);
